import { render } from "./DADataTableLazy.vue?vue&type=template&id=5431f276&scoped=true"
import script from "./DADataTableLazy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy.vue?vue&type=script&lang=js"

import "./DADataTableLazy.vue?vue&type=style&index=0&id=5431f276&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5431f276"]])

export default __exports__